import { Routes } from '@angular/router';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { ThanksCardComponent } from './components/thanks-card/thanks-card.component';
import { BlockFinalOnNewReferralGuard } from './guards/block-final-referralguard';

export const routes: Routes = [
  { path: 'final', component: ThanksCardComponent, canActivate: [BlockFinalOnNewReferralGuard] },
  { path: ':code', component: UserDetailsComponent, runGuardsAndResolvers: 'always' }
];


